import { trackersCapture, trackersHandOver, trackersIdentify } from '@/lib/trackers'

/*
 * The page's side of the steps Bindle counts. The server tells every step it
 * takes itself; the page adds only what it alone sees, and hands Google and
 * Meta the steps the server took for this visitor. Names come from the
 * server's list, `config/analytics.php`, through the `analytics` page prop.
 */
let catalog = {}

export function analyticsPageRead(analytics, user) {
  catalog = analytics?.catalog ?? catalog
  trackersIdentify(user, analytics?.labels, analytics?.landing)

  for (const event of analytics?.events ?? []) {
    trackersHandOver(event)
  }
}

export function trackEvent(event, properties = {}) {
  const names = catalog[event]

  if (!names) {
    console.warn(`[Analytics] Event '${event}' is not in the list of steps.`)
    return
  }
  trackersCapture(event, names, properties)
}
